import {
  Alert,
  Button,
  Card,
  CardBody,
  Grid,
  Table,
} from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import CellHeadings from '../../components/CellHeadings';
import CopyToClipboardWithIcon from '../../components/Copy';
import CardHeader from '../../components/CardHeader';
import MetadataSelection from '../../components/MetadataSelection';
import MetadataSelections from '../../components/MetadataSelections';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import themeHelper from '../../utils/themeHelper';

const ButtonContainer = styled.div`
  padding-top: ${themeHelper.spacing(1)};
`;

export function FrameExtraction() {
  const api = useApi();
  const intl = useIntl();

  const [lastSubmittedMatchId, setLastSubmittedMatchId] = useState(0);
  const [lastSubmittedMatchPart, setLastSubmittedMatchPart] = useState(0);

  const selectedMetadata = useAtomValue(selectedMetadataAtom);
  const {
    sport,
    matchId,
    period: matchPart,
    version,
    track,
  } = selectedMetadata;

  const [timestamp, setTimestamp] = useState('0');

  const downloadRequestClick = async () => {
    setLastSubmittedMatchId(matchId);
    setLastSubmittedMatchPart(matchPart);
    api.get(
      `${API_ENDPOINTS.videoService}/matches/${sport}/${matchId}/videos/${matchPart}/${track}/${version}/${timestamp}`,
    );
  };

  return (
    <Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader>
            <FormattedMessage
              defaultMessage="Match Frame"
              description="Match Frame Title"
              id="0afc6"
            />
          </CardHeader>
          <CardBody>
            {api.errorMessage && <Alert type="error">{api.errorMessage}</Alert>}
            <MetadataSelection />
            <div>
              <MetadataSelections.Timestamp
                readOnly={false}
                setTimestamp={setTimestamp}
                timestamp={timestamp}
              />
            </div>
            <ButtonContainer>
              <Button
                onClick={() => downloadRequestClick()}
                disabled={!api.isFetching}
                isPending={api.isFetching}
              >
                <FormattedMessage
                  defaultMessage="Request Match Video Frame"
                  id="40682"
                />
              </Button>
            </ButtonContainer>
          </CardBody>
        </Card>
      </Grid>
      {api.response?.data?.base64 && !api.isFetching && (
        <Grid item xs={12}>
          <Card>
            <CardHeader>
              <FormattedMessage
                defaultMessage="Requested Files"
                description="Requested Files"
                id="75cee"
              />
            </CardHeader>
            <CardBody>
              <Table size="small" aria-label="Uploads">
                <CellHeadings
                  cells={[
                    {
                      children: intl.formatMessage({
                        defaultMessage: 'Match ID',
                        description: 'Upload title: match id',
                        id: 'a6ee0',
                      }),
                      id: 'id',
                    },
                    {
                      children: intl.formatMessage({
                        defaultMessage: 'Match Part',
                        description: 'Upload title: match part',
                        id: '0bb8e',
                      }),
                      id: 'part',
                    },
                    {
                      children: intl.formatMessage({
                        defaultMessage: 'Actions',
                        description: 'Upload title: Actions',
                        id: 'a555a',
                      }),
                      id: 'actions',
                    },
                  ]}
                  textAlign="left"
                />
                <Table.Body>
                  <Table.Row>
                    <Table.DataCell $textAlign="left">
                      {lastSubmittedMatchId}
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      {lastSubmittedMatchPart}
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      <CopyToClipboardWithIcon
                        text={api.response?.data?.base64}
                      />
                    </Table.DataCell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </CardBody>
          </Card>
        </Grid>
      )}
      {api.response?.data?.base64 && (
        <Grid item xs={12}>
          <Card>
            <CardHeader>
              <FormattedMessage
                defaultMessage="Requested Image Preview"
                description="Requested Image Preview"
                id="cbced"
              />
            </CardHeader>
            <CardBody>
              <img
                src={api.response?.data?.base64}
                alt="base64 of requested frame"
              />
            </CardBody>
          </Card>
        </Grid>
      )}
    </Grid>
  );
}

export default { FrameExtraction };
